module.exports = __webpack_public_path__ + "static/media/game-preview.efbfc1c3.png";